// extracted by mini-css-extract-plugin
export default {"section":"section__afxm9","content":"content__iTKhr"};